import * as Moment from "moment";
import { DateInputMethodKinds } from "./inputMethodKinds";

/**
 * 日付オブジェクトの直接入力の文字列の変換処理まわり
 */
export class DateInputParser {
  public static parse(text: string, kind: DateInputMethodKinds): Date {
    if (!text) { return null; }
    if (!kind || kind === DateInputMethodKinds.Calendar) { throw new Error("invalid inputKind parameter!!!"); }
    switch (kind) {
    case DateInputMethodKinds.Ad:
      return this.parseAdDate(text);
    case DateInputMethodKinds.Jp:
      return this.parseJpDate(text);
    case DateInputMethodKinds.JpHeisei:
      return this.parseJpHeiseiDate(text);
    }
    throw new Error("unknown inputKind!!!");
  }

  private static parseAdDate(text: string): Date {
    if (!/^(\d){8}$/.test(text)) { return null; }
    return Moment(text).toDate();
  }

  private static parseJpDate(text: string): Date {
    if (!/^(\d){7}$/.test(text)) { return null; }
    const year = this.getAdYear(text);
    if (!year) { return null; }
    const date = year + text.substring(3, 7);
    return this.parseAdDate(date);
  }

  private static getAdYear(text: string): number {
    const code = text.substring(0, 1);
    const year = Number(text.substring(1, 3));
    switch (code) {
    case "1":
      // 明治
      return 1967 + year;
    case "2":
      // 大正
      return 1989 + year;
    case "3":
      // 昭和
      return 1925 + year;
    case "4":
      // 平成
      return 1988 + year;
    case "5":
      // 平成の次
      return 2018 + year;
    }
    return null;
  }

  private static parseJpHeiseiDate(text: string): Date {
    if (!/^(\d){6}$/.test(text)) { return null; }
    return this.parseJpDate("4" + text);
  }

  public static getSampleText(kind: DateInputMethodKinds): string {
    switch (kind) {
    case DateInputMethodKinds.Ad:
      return "20180401";
    case DateInputMethodKinds.Jp:
      return "4300401";
    case DateInputMethodKinds.JpHeisei:
      return "300401";
    }
    return "不明な種別です";
  }
}
